/**
*
* Disclaimer: Source code mentioned below is(are) Intellectual Property of
* Crayon Data Holdings Limited (including its subsidiaries and affiliates).
* Crayon Data Holdings Limited reserves right to own and control it the way
* it may deem fit. You must refrain from use, access, read, modify, add or
* delete, sell or use in any other package or programme pertaining to such
* source code without explicit prior written approval of
* Crayon Data Holding Limited. Breach of the same shall attract penalty as
* applicable.
*
*/

// MerchantCardCarousel Component
import React, { PureComponent } from "react";
import Slider from "react-slick";
import ContentLoader from "react-content-loader";

import Icon from "../Icons";
import { formatDateDDMMMYYYY } from "../../pages/helper";
import uiConfig from "../../uiConfig";

export default class MerchantCardCarousel extends PureComponent {
  state = {
    isLoad: true
  };

  componentDidMount() {
    this.updateRenderLoad();
  }

  updateRenderLoad = () => {
    setTimeout(() => {
      //Start the timer
      this.setState({ isLoad: false }); //After 5 second, set render to true
    }, 5000);
  };

  onShowAllOffer = () => {
    const { history } = this.props;

    if (history) {
      history.push("/home", "allOffers");
    }
  };

  _onClick = (data) => {
    const { history } = this.props;

    if (history) {
      history.push(`/home/merchant/${data.id}`);
    }
  };

  /* Main Render Functions */
  render() {
    const { itemList } = this.props;

    const settings = {
      dots: false,
      infinite: false,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1
    };

    return (
      <div className="card_carousel">
        <Slider {...settings} ref={(c) => (this.slider = c)}>
          {itemList.map((eachItem) =>
            eachItem.offers.map((item) => (
              <div
                key={`${eachItem.id}`}
                className="content"
                onClick={() => this._onClick(eachItem)}
              >
                {this.state.isLoad && (
                  <ContentLoader speed={0.7} height={234}>
                    <rect x="0" y="0" rx="5" ry="5" width="190" height="100" />
                    <rect x="0" y="110" rx="4" ry="4" width="190" height="13" />
                    <rect x="0" y="130" rx="3" ry="3" width="190" height="10" />
                    <rect x="0" y="150" rx="3" ry="3" width="190" height="10" />
                    <rect x="0" y="170" rx="3" ry="3" width="190" height="10" />
                    <rect x="0" y="190" rx="3" ry="3" width="190" height="10" />
                  </ContentLoader>
                )}
                {!this.state.isLoad && ( 
                  <div className={`img-content common-bg`} style={uiConfig.config.whitelabel.common_background_color}>
                    <div className="card-info flex">
                      <div className="col-lft flex-start" style={uiConfig.config.whitelabel.components.campaign_card.is_online_tag}>
                        {item.isOnline ? "Online" : "Instore"}
                      </div>
                      <div className="col-rgt _ai-self flex-end">
                        <Icon name="heart" width={14} height={12} fill="#FFF" />
                      </div>
                    </div>
                    <div className="flex-center">
                      <img
                        src={eachItem.properties.image}
                        width={90}
                        height={84}
                        alt="img"
                      />
                    </div>
                  </div>
                )}
                {!this.state.isLoad && (
                  <div className="col-md-12 p-0 info-content">
                    <div className="info-div ellipsis"  style={uiConfig.config.whitelabel.components.campaign_card.card_title}>{item.description}</div>
                    <div className="card-det" style={uiConfig.config.whitelabel.components.campaign_card.card_expire}>
                      <div className="col-md-12 p-0 tit">Expires:</div>
                      <div className="col-md-12 p-0 mt-4 expirees-info">
                        <div className="col-md-5 p-0">
                          {formatDateDDMMMYYYY(item.validTo)}
                        </div>
                        <div className="col-md-4 p-0 rating">
                          <div className="dot mr-10" />
                          <div className="star _ai-self">
                            <Icon name="star" width={14} height={14} />
                          </div>
                          <span className="rat-tit">NA</span>
                        </div>
                        <div className="col-md-3 p-0 rating">
                          <div className="dot mr-10" /> NA
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))
          )}
        </Slider>
      </div>
    );
  }
}
